{
  "printer": {
    "NO_PAPER": "لا يوجد ورق في الطابعة",
    "OVERHEATED": "الطابعة ساخنة، انتظر قليلا",
    "UNAVAILABLE": "الطابعة غير متاحة",
    "UNKNOWN": "تعذرت الطباعة، حاول مجددا",
    "blocked": "تعذر فتح نافذة الطباعة. اسمح بالنوافذ المنبثقة ثم أعد المحاولة"
  },
  "scanner": {
    "hint": "وجه الكاميرا إلى رمز QR في الوصل",
    "cancel": "إلغاء",
    "permissionDenied": "تعذر استخدام الكاميرا. اسمح بها من الإعدادات أو أدخل الرقم يدويا",
    "unavailable": "الكاميرا غير متاحة على هذا الجهاز",
    "unreadable": "تعذر قراءة الرمز، حاول مجددا أو أدخل الرقم يدويا",
    "title": "مسح الوصل",
    "starting": "جاري فتح الكاميرا..."
  },
  "receipt": {
    "reference": "رقم الحركة",
    "quantity": "الكمية",
    "operation": "نوع العملية",
    "product": "المادة",
    "purchase": "شراء",
    "imageAlt": "وصل شراء",
    "sale": "بيع"
  }
}
